/*
This handles the Help Links Overlay.  In order to have contextual buttons we need a place to store them.
When a view is loaded it will pass a JSON list of contextual buttons to this sore, where it will be added to the list of default buttons.

When a route name changes the HelpLinksOverlay component will check to see if the route name is included in the sored JSON.
If not, it will wipe the stored JSON and replace it with the default.
 */

// import router from '@/router'

const types = {
  ADD_ERROR: 'ADD_ERROR',
  CLEAR_ERRORS: 'CLEAR_ERRORS'
}

const getDefaultState = () => {
  return {
    errorList: []
  }
}

// initial state
const state = getDefaultState()

// getters
const getters = {
  errorList: state => state.errorList
}

// actions
const actions = {
  addError ({ commit }, payload) {
    commit(types.ADD_ERROR, payload)
  },
  clearErrors ({ commit }) {
    commit(types.CLEAR_ERRORS)
  }
}

// mutations
const mutations = {
  [types.ADD_ERROR] (state, payload) {
    if (Array.isArray(payload)) {
      state.errorList = [...state.errorList, ...payload]
    } else {
      state.errorList = [...state.errorList, payload]
    }
  },
  [types.CLEAR_ERRORS] (state) {
    state.errorList = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
